/**
 * fetchMeta / partyboss meta payloads — unwrap nested shapes and drop inactive add-ons.
 */
export function normalizeAddonMetaPayload(raw) {
  if (raw == null || typeof raw !== "object") {
    return { addonsData: {}, slotOffers: [] };
  }

  let inner = raw;
  if (inner.data && typeof inner.data === "object") {
    inner = inner.data;
  }
  if (!inner.addonsData && inner.result && typeof inner.result === "object") {
    inner = inner.result;
  }

  const src = inner.addonsData;
  if (!src || typeof src !== "object") {
    return { ...inner, addonsData: {}, slotOffers: Array.isArray(inner.slotOffers) ? inner.slotOffers : [] };
  }

  const addonsData = {};
  Object.keys(src).forEach((cat) => {
    const items = src[cat];
    if (!Array.isArray(items)) return;
    addonsData[cat] = items.filter((it) => {
      if (!it || typeof it !== "object") return false;
      if (it.isActive == null) return true;
      return String(it.isActive).toUpperCase() === "Y";
    });
  });

  const slotOffers = Array.isArray(inner.slotOffers) ? inner.slotOffers : [];
  return { ...inner, addonsData, slotOffers };
}
